import { createApp } from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import { supabase } from '@/supabase'
import { createPinia } from 'pinia';
const pinia = createPinia();




import 'primevue/resources/primevue.min.css';
import '/node_modules/primeflex/primeflex.css';
import 'primevue/resources/themes/lara-light-purple/theme.css';

import 'primeicons/primeicons.css';
import Tooltip from 'primevue/tooltip';




supabase.auth.onAuthStateChange(async (event, session) => {

    store.commit('setLoading', true)
    const userSession = store.state.userSession;

    if(session && userSession){
        store.commit('setLoading', false)
        return
    }
    if (session) {
        try {
            store.commit('setUserSession', session);
            await verifUser(session);
        } catch (error) {

        }
    } else {
        store.commit('setLoading', false)
        store.commit('setUserSession', null);
        

    }
});


async function verifUser(userSession) {
    store.dispatch('updatePaginaFazerLogin', false)
    store.commit('setLoading', true);

    console.log(userSession);

    try {

        const metadata = userSession.user.user_metadata || {};
        // fallback pra contas Azure sem o atributo "mail" preenchido no Entra ID
        const emailTeams = metadata.email || metadata.preferred_username || metadata.upn;

        let orFilter = `email.eq.${userSession.user.email}`;
        if (emailTeams) {
            orFilter += `,email_teams.eq.${emailTeams}`;
        }

        let { data, error } = await supabase
            .from('users')
            .select('*, disciplinas(*)')
            // verificar também se o email_secundario
            .or(orFilter);



        if (error) {
            store.dispatch('updatePaginaFazerLogin', true)
            return;
        }


        if (data && data.length > 0) {

            userSession.user.idU = data[0].id;
            userSession.user.funcao = data[0].funcao;
            userSession.user.disciplina = data[0].disciplina;
            if(data[0].disciplinas){
                userSession.user.areaId = data[0].disciplinas.id_area;
                userSession.user.areaNome = data[0].disciplinas.area_conhecimento;
                userSession.user.disciplinaNome = data[0].disciplinas.nome;
            }
     
            store.commit('setUserSession', userSession);
            router.push('/' + data[0].funcao);
            store.dispatch('updatePaginaFazerLogin', true)
        } else {
            store.commit('setUserSession', null);
            store.dispatch('updatePaginaFazerLogin', true)
            await supabase.auth.signOut();
            alert('Esse email não está cadastrado. Envie mensagem para o professor William Godoy no Teams com seu email para se cadastrar.');
        }
    } catch (error) {
        console.error('Erro ao executar verifUser:', error);
    } finally {
        store.dispatch('updatePaginaFazerLogin', true)
        store.commit('setLoading', false);

    }
}



createApp(App)
.use(pinia)
.use(store)
.use(router)
.use(PrimeVue, { ripple: true })
.use(ToastService)
.directive('tooltip', Tooltip)
.mount('#app')


